import dayjs from "dayjs"
import { useMemo } from "react"
import {
  useEntryLoading,
  useEventLoading,
} from "src/contexts/LoadingContexts"
import { useThisMinute } from "src/hooks"

/*
 * show loading indicator when:
 * - we haven't loaded any data yet
 * - we are loading data and haven't loaded the last 10 minutes of data yet
 */
export function useIsLoadingRecentGlucoseData() {
  const thisMinute = useThisMinute()

  const eventLoading = useEventLoading()
  const entryLoading = useEntryLoading()

  const loadUntilTime = useMemo(
    () => dayjs(thisMinute).subtract(
      15,
      "minutes",
    )
      .toISOString(),
    [thisMinute],
  )

  const isLoadingEvents = eventLoading.loading
    ? eventLoading.loadedAfter === null ||
      dayjs(eventLoading.loadedAfter).isAfter(loadUntilTime)
    : eventLoading.error === null &&
      !eventLoading.loaded

  const isLoadingEntries = entryLoading.loading
    ? entryLoading.loadedAfter === null ||
      dayjs(entryLoading.loadedAfter).isAfter(loadUntilTime)
    : entryLoading.error === null &&
      !entryLoading.loaded

  return isLoadingEvents || isLoadingEntries
}
